export default "__VITE_PUBLIC_ASSET__509aedb5__"